import React, { Component } from 'react';
import { connect } from 'react-redux';
import ImageDiv from './ImageDiv';
import MainText from './MainText';
import ToolBar from './Toolbar';

class ImageLayout extends Component {
    render() {
        return (
            <div className="layout-page">
                {/* this scene has a title, some action buttons, stored in an array, with type data, visual elements (how many? what type?) stored in an array, with type data, and data about next available scenes, stored in an array */}
                <div className="flex-box flex-center">

                    <div className="column-lg-12 column-md-12 column-sm-12">
                    {this.props.activeScene.title !== null && <h2><span className="title">{this.props.activeScene.title}</span></h2>} 
                    </div>
                </div>
                <div className="flex-box flex-center">
               {this.props.activeScene.text.length > 0 && <div className=" column-lg-6 column-md-12 column-sm-12">
                    {this.props.activeScene.text.map((text, i) => {
                        return (<MainText className={`text-div text-light-div`} text={text} key={i}/>)
                    })}
                </div>}
              
                {this.props.activeScene.images.map((image, i) => {
                return (<ImageDiv columns={`column-lg-5 column-sm-12 column-md-12`} divClass={`image-space `} image={image} key={i}/>);
            })}
           
            </div>
                
                <ToolBar history={this.props.history}/>
            </div>

        );
    }
}
const mapStateToProps = state => ({
    activeScene: state.activeScene
})
export default connect(mapStateToProps)(ImageLayout);